import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PlusXs = ({ color = 'currentColor', ...props })=>/*#__PURE__*/ _jsxs("svg", {
        fill: "none",
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("g", {
                clipPath: "url(#clip0_8774_22679)",
                children: /*#__PURE__*/ _jsx("path", {
                    clipRule: "evenodd",
                    d: "M8.75 2.75C8.75 2.33579 8.41421 2 8 2C7.58579 2 7.25 2.33579 7.25 2.75V7.25H2.75C2.33579 7.25 2 7.58579 2 8C2 8.41421 2.33579 8.75 2.75 8.75H7.25V13.25C7.25 13.6642 7.58579 14 8 14C8.41421 14 8.75 13.6642 8.75 13.25V8.75H13.25C13.6642 8.75 14 8.41421 14 8C14 7.58579 13.6642 7.25 13.25 7.25H8.75V2.75Z",
                    fill: color,
                    fillRule: "evenodd"
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_8774_22679",
                    children: /*#__PURE__*/ _jsx("rect", {
                        fill: "white",
                        height: "16",
                        width: "16"
                    })
                })
            })
        ]
    });

//# sourceMappingURL=plus-xs.js.map